import { render, staticRenderFns } from "./AddFundsModal.vue?vue&type=template&id=f6b1d660&"
import script from "./AddFundsModal.vue?vue&type=script&lang=js&"
export * from "./AddFundsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports